var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("数据看板/PO看板")]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("div", { staticClass: "card-header" }, [_vm._v("PO统计")]),
                  _c(
                    "el-table",
                    { attrs: { data: _vm.poStatistics, border: "" } },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "category", label: "类别" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "total", label: "汇总" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "thisYear", label: "今年" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "last30Days", label: "近30天" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "last7Days", label: "近7天" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("div", { staticClass: "card-header" }, [_vm._v("PO超时")]),
                  _c(
                    "el-table",
                    { attrs: { data: _vm.poTimeout, border: "" } },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "category", label: "类别" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "total", label: "统计汇总" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "thisYear", label: "今年" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "last30Days", label: "近30天" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "last7Days", label: "近7天" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card mt-20" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("div", { staticClass: "card-header" }, [
                    _vm._v("PO统计（区域-园区）")
                  ]),
                  _c(
                    "el-table",
                    { attrs: { data: _vm.poRegionStatistics, border: "" } },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "category", label: "类别" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "total", label: "汇总" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "thisYear", label: "今年" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "last30Days", label: "近30天" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "last7Days", label: "近7天" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("div", { staticClass: "card-header" }, [
                    _vm._v("PO受理/驳回")
                  ]),
                  _c(
                    "el-table",
                    { attrs: { data: _vm.poHandling, border: "" } },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "category", label: "类别" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "poCount", label: "PO数" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "accepted", label: "受理" }
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "rejected", label: "驳回" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("el-card", { staticClass: "box-card mt-20" }, [
        _c("div", { staticClass: "card-header" }, [
          _vm._v("PO分析（柱状图-近12月/按月/按类别）")
        ]),
        _c(
          "div",
          { staticStyle: { height: "400px" } },
          [_c("POAnalysisChart")],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }